import React, { createContext, useContext, useState } from 'react';

const BeneficiarioEventualContext = createContext({});

export function useBeneficiarioEventual() {
    const context = useContext(BeneficiarioEventualContext);
    return context;
}

export function BeneficiarioEventualProvider({ children }) {
    const [alerts, setAlerts] = useState([]);
    const [dataDadosTitular, setDataDadosTitular] = useState({});
    const [dataDadosEmpresa, setDataDadosEmpresa] = useState({});
    const [dataDadosBeneficiario, setDataDadosBeneficiario] = useState({});
    const [dataDadosPlano, setDadosPlano] = useState({});
    const [dataDadosPayLoad, setDataDadosPayLoad] = useState({});
    const [dataConsultaAtendimento, setDataConsultaAtendimento] = useState({});
    const [dataConsultaAcidentadosAtendimento, setDataConsultaAcidentadosAtendimento] = useState({});
    const [datasDisponiveis, setDatasDisponiveis] = useState();
    const [dataEspecialidade, setDataEspecialidade] = useState();
    const [dataRegiao, setDataRegiao] = useState();
    const [telefoneConsulta, setTelefoneConsulta] = useState();
    const [emailConsulta, setEmailConsulta] = useState();
    const [localidade, setDataLocalidade] = useState();
    const [periodoDia, setperiodoDia] = useState();

    function clearBeneficiarioEventual() {
        setAlerts([]);
        setDataDadosTitular({});
        setDataDadosEmpresa({});
        setDataDadosBeneficiario({});
        setDadosPlano({});
        setDataDadosPayLoad({});
        setDataConsultaAtendimento({});
        setDataConsultaAcidentadosAtendimento({});
        setDatasDisponiveis();
        setDataEspecialidade();
        setDataRegiao();
        setTelefoneConsulta();
        setEmailConsulta();
        setDataLocalidade();
        setperiodoDia();
    }

    return (
        <BeneficiarioEventualContext.Provider
            value={{
                alerts,
                setAlerts,
                dataDadosTitular,
                setDataDadosTitular,
                dataDadosEmpresa,
                setDataDadosEmpresa,
                dataDadosBeneficiario,
                setDataDadosBeneficiario,
                dataDadosPlano,
                setDadosPlano,
                dataDadosPayLoad,
                setDataDadosPayLoad,
                dataConsultaAtendimento,
                setDataConsultaAtendimento,
                dataConsultaAcidentadosAtendimento,
                setDataConsultaAcidentadosAtendimento,
                datasDisponiveis,
                setDatasDisponiveis,
                dataEspecialidade,
                setDataEspecialidade,
                dataRegiao,
                setDataRegiao,
                telefoneConsulta,
                setTelefoneConsulta,
                emailConsulta,
                setEmailConsulta,
                localidade,
                setDataLocalidade,
                periodoDia,
                setperiodoDia,
                clearBeneficiarioEventual,
            }}
        >
            {children}
        </BeneficiarioEventualContext.Provider>
    );
}
